import React from 'react';

interface ErrorPopupProps {
  title: string;
  messages: string[];
  onClose: () => void;
}

const ErrorPopup: React.FC<ErrorPopupProps> = ({ title, messages, onClose }) => {
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
      <div className="relative flex flex-col bg-white p-5 rounded shadow-md w-1/3 gap-4">
        {/* Close button in the top-right corner */}
        <button
          onClick={onClose}
          className="absolute top-2 right-4 text-gray-600 hover:text-gray-900"
        >
          ✕
        </button>
        
        <h2 className="text-title font-bold mb-4">{title}</h2>
        <ul className="list-none list-inside">
          {messages.map((message, index) => (
            <li key={index} className="text-gray-600">{message}</li>
          ))}
        </ul>
        <button
          onClick={onClose}
          className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ErrorPopup;